import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../webcommon/grid/Grid';
import { noop } from 'lodash';
import GridHeader from '../../common/gridheader/GridHeader';
import ExportAsCsvButton from '../../common/gridheader/exportbutton/ExportAsCsvButton';
import gridHeaderStyles from './GridHeaderOverride.module.scss';
import gridStyles from './GridOverride.module.scss';

const CustomGrid = props => (
    <div className={ props.styles.customGrid }>
        <GridHeader
            title={ props.title }
            styles={ gridHeaderStyles }
        >
            <ExportAsCsvButton
                csvData={ props.rows }
                csvFilename={ props.csvFilename }
                csvMapping={ props.csvMapping }
            />
        </GridHeader>
        <Grid
            defaultColumnSpacing={ 2 }
            defaultSorted={ props.defaultSorted }
            filterable={ props.filterable }
            loading={ props.loading }
            onSortedChange={ props.onSortedChange }
            styles={ gridStyles }
            columns={ props.columns }
            rows={ props.rows }
            pagination={ props.pagination }
            setRowChecked={ props.setRowChecked }
        />
    </div>
);

CustomGrid.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string
    })),
    csvFilename: PropTypes.string,
    csvMapping: PropTypes.func,
    defaultSorted: PropTypes.arrayOf(
        PropTypes.shape({
            gridId: PropTypes.string,
            gridSort: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.string,
                desc: PropTypes.bool
            }))
        })
    ),
    filterable: PropTypes.bool,
    loading: PropTypes.bool,
    onSortedChange: PropTypes.func,
    pagination: PropTypes.bool,
    rows: PropTypes.arrayOf(PropTypes.shape({})),
    styles: PropTypes.objectOf(PropTypes.string),
    title: PropTypes.string,
    setRowChecked: PropTypes.func
};

CustomGrid.defaultProps = {
    columns: [],
    csvFilename: 'file.csv',
    csvMapping: row => row,
    defaultSorted: [],
    filterable: false,
    loading: false,
    onSortedChange: noop,
    pagination: false,
    rows: [],
    styles: {},
    title: '',
    setRowChecked: noop
};

export default CustomGrid;
